// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.88.0-beta.a1ab1092a',
  revision: 'a1ab1092a',
  branch: 'develop',
  date: 'Mon, 15 Jun 2026 09:09:11 GMT'
};